import React from 'react';
import RefreshButton from '../../components/RefreshButton';
import { Dayjs } from 'dayjs';
import { Box } from '@mui/material';
import { AdminTierTypeEnum } from '../../services/drillDown';
import CardDatePicker from '../../components/CardDatePicker';

interface ReportsHeaderProps {
  selectedDate: Dayjs | null;
  onDateChange: (date: Dayjs | null) => void;
  onRefresh: () => void;
  earliestDate: Dayjs | null;
  isCurrentDate: boolean | undefined;
  today: Dayjs;
  tier: AdminTierTypeEnum | undefined;
  gcInternalAdmin: boolean;
  loading: boolean | undefined;
}

const ReportsHeader: React.FC<ReportsHeaderProps> = ({
  selectedDate,
  onDateChange,
  onRefresh,
  earliestDate,
  isCurrentDate,
  today,
  tier,
  gcInternalAdmin,
  loading,
}) => {
  return (
    <Box
      sx={{
        'display': 'flex',
        'flexDirection': 'row',
        'alignItems': 'center',
        'justifyContent': 'flex-end',
        'gap': 2,
        'flexWrap': 'nowrap',
        'ml': 'auto',
        'minWidth': 'fit-content',
        '& > *': {
          flexShrink: 0,
        },
      }}>
      {isCurrentDate && (tier === AdminTierTypeEnum.Root || gcInternalAdmin) && (
        <RefreshButton onRefresh={onRefresh} disabled={loading} />
      )}
      <CardDatePicker
        initialDate={selectedDate}
        onDateChange={onDateChange}
        minDate={earliestDate}
        maxDate={today}
      />
    </Box>
  );
};

export default ReportsHeader;
